
import Vue from "vue";

export default Vue.extend({
  name: "HomeBanner",
  props: {
    occasion: {
      type: Object,
      default: null,
    },
  },
  computed: {
    bannerImageUrl(): string {
      const occasion = this.occasion as {
        bannerImagePreviewUrl?: string;
        bannerImage?: string;
      } | null;

      return (
        occasion?.bannerImagePreviewUrl ||
        occasion?.bannerImage ||
        ""
      );
    },
    bannerAlt(): string {
      const occasion = this.occasion as {
        name?: string;
      } | null;
      const occasionName = occasion?.name;

      return occasionName
        ? `Banner catálogo ${occasionName}`
        : "Banner catálogo ChileConverge";
    },
    hasConfiguredBanner(): boolean {
      return Boolean(this.bannerImageUrl);
    },
  },
});
